import React from 'react'

interface IProps {
  children: string | JSX.Element | JSX.Element[]
  href: string
}

class NewTabLink extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <a href={this.props.href} target="_blank" rel="noopener noreferrer">
        {this.props.children}
      </a>
    )
  }
}

export default NewTabLink
